var path = 'entity/entity-select.tpl.html';
var html = "\n<div layout='row' class=\"tb-entity-select\">\n    <tb-entity-type-select style=\"min-width: 100px;\" ng-if=\"displayEntityTypeSelect\" the-form=\"theForm\" ng-disabled=\"disabled\" tb-required=\"tbRequired\" use-alias-entity-types=\"useAliasEntityTypes\" allowed-entity-types=\"allowedEntityTypes\" ng-model=\"model.entityType\">\n    </tb-entity-type-select>\n    <tb-entity-autocomplete flex ng-if=\"model.entityType\" the-form=\"theForm\" ng-disabled=\"disabled\" tb-required=\"tbRequired\" entity-type=\"model.entityType\" ng-model=\"model.entityId\">\n    </tb-entity-autocomplete>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/entity/entity-select.tpl.html
// module id = 1469
// module chunks = 1